import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Translation, TranslocoLoader } from '@ngneat/transloco';

@Injectable({
    providedIn: 'root',
})
export class TranslocoHttpLoader implements TranslocoLoader {
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation> {
        return this._httpClient.get<Translation>(`assets/i18n/${lang}.json?v=${TranslocoHttpLoader.buildId()}`);
    }

    /**
     * Cache-Buster für die Sprachdateien: nginx liefert /assets/ mit 30 Tagen Cache, die JSON-Dateien
     * haben aber keinen Hash im Namen. Ohne Buster zeigt der Browser nach einem Deploy alte Texte bzw.
     * rohe Schlüssel. Als Version dient der Hash des main-Bundles (ändert sich mit jedem Build);
     * im Dev-Build ohne Hash fällt es auf einen Zeitstempel zurück.
     */
    private static buildId(): string {
        const main = Array.from(document.scripts)
            .map((script) => script.getAttribute('src') || '')
            .find((src) => /(^|\/)main\.[0-9a-f]{8,}\.js$/.test(src));
        const hash = main?.match(/main\.([0-9a-f]{8,})\.js$/)?.[1];
        return hash || String(Date.now());
    }
}
